<template><div><h1 id="ab-journal-nach-konto-mwst" tabindex="-1"><a class="header-anchor" href="#ab-journal-nach-konto-mwst"><span>AB-Journal nach Konto, MWST</span></a></h1>
<p>AB-Journal nach Konto, MWST — Liste aus aggregierten Buchungen nach Konto, MWst</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste aus aggregierten Buchungen, in denen die bebuchten Kombinationen von Buchungstyp und Soll/Habenkonto ausgewiesen sind. Eingrenzung nach Journalnummern [Journalnummer von - bis] und Mandant ist möglich. Sortierung nach Konto oder MWST wählbar. Pro Soll/Habenkonto oder pro MWST-Code (je nach Sortierung) werden auch die Summen der Spalten &quot;Betrag&quot; und &quot;Saldo&quot; angezeigt. In der Rekapitulation werden die Gesamtwerte des Berichts ausgewiesen.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → AB-Kontoauszüge → AB-Journal nach Konto, MWST</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<ul>
<li>
<p>Journalnummer von:
: inklusive, ? = unbegrenzt (wenn 'bis' = ?: bis Journalnummer)</p>
</li>
<li>
<p>bis:
: inklusive, ? = unbegrenzt (wenn 'Journalnummer von' = ?: Journalnummer von)</p>
</li>
<li>
<p>Sortierung nach:
: K = Konto, M = MWST</p>
</li>
<li>
<p>Mandant:
: leer = alle Mandanten</p>
</li>
</ul>
<dl>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
<dt>- Bildschirm</dt>
<dd>
<ul>
<li>Bildschirm</li>
</ul>
</dd>
<dt>- Drucker:</dt>
<dd>A4 quer</dd>
<dt>- Textdatei:</dt>
<dd>Text</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Informationsfelder:</td>
<td>Informationsfelder:</td>
</tr>
<tr>
<td>Journalnummer:</td>
<td>Journalnummer von - bis</td>
</tr>
<tr>
<td>Sortierung:</td>
<td>Sortierung gemäss gewähltem Parameter</td>
</tr>
<tr>
<td>Mandant:</td>
<td>Mandant gemäss gewähltem Parameter</td>
</tr>
<tr>
<td>Spalten:</td>
<td>Spalten:</td>
</tr>
<tr>
<td>- BelegNr:</td>
<td>Belegnummer der aggregierten Buchung</td>
</tr>
<tr>
<td>- T:</td>
<td>Buchungstyp</td>
</tr>
<tr>
<td>- Belegdatum:</td>
<td>Belegdatum</td>
</tr>
<tr>
<td>- Sollkonto:</td>
<td>Sollkonto der Buchung</td>
</tr>
<tr>
<td>- Habenkonto:</td>
<td>Habenkonto der Buchung</td>
</tr>
<tr>
<td>- Kostenstelle:</td>
<td>Kostenstelle der Buchung</td>
</tr>
<tr>
<td>- M:</td>
<td>MWST-Code der Buchung</td>
</tr>
<tr>
<td>- Betrag:</td>
<td>Buchungsbetrag</td>
</tr>
<tr>
<td>- Saldo:</td>
<td>Saldo der Buchungszeile</td>
</tr>
<tr>
<td>Zeilen:</td>
<td>Zeilen:</td>
</tr>
<tr>
<td>- TOTAL :</td>
<td>Total für Spalten 'Betrag' und 'Saldo' pro Habenkonto bzw. MWST-Code</td>
</tr>
<tr>
<td>- COUNT :</td>
<td>Anzahl der Belegnummern pro Habenkonto bzw. MWST-Code</td>
</tr>
<tr>
<td>Rekapitulation am Ende der Auswertung</td>
<td>Rekapitulation am Ende der Auswertung</td>
</tr>
<tr>
<td>Spalten:</td>
<td>Spalten:</td>
</tr>
<tr>
<td>- Betrag:</td>
<td>Total Betrag aus allen verarbeiteten Buchungsbelegen</td>
</tr>
<tr>
<td>- Saldo :</td>
<td>Total Saldo aus allen verarbeiteten Buchungsbelegen</td>
</tr>
<tr>
<td>Zeilen:</td>
<td>Zeilen:</td>
</tr>
<tr>
<td>- Umsatz :</td>
<td>Summe der Umsatz-Beträge = Nettoumsätze ohne MWST</td>
</tr>
<tr>
<td>- MWST:</td>
<td>Summe der MWST-Beträge</td>
</tr>
<tr>
<td>- TOTAL :</td>
<td>Total der Spalten 'Betrag' und 'Saldo' aus allen verarbeiteten Belegnummern</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                                29.10.1998 13:27:11 pav  Seite     0</span>
<span class="line"></span>
<span class="line">                              AB-Kontostatistik</span>
<span class="line"></span>
<span class="line">               Achtung: Programm braucht 132 Zeichen / Zeile</span>
<span class="line"></span>
<span class="line">                Journalnummer von:   1003 bis:   1003</span>
<span class="line">                Sortierung nach..: K</span>
<span class="line">                Mandant..........:</span>
<span class="line"></span>
<span class="line">BelegNr T  Belegdatum Sollkonto    Habenkonto   Kostenstelle M         Betrag</span>
<span class="line">      Saldo</span>
<span class="line">------- -- ---------- ------------ ------------ ------------ - -------------- --</span>
<span class="line">    376 S  31.01.97   1100.990     1100.985                             50.00         50.00</span>
<span class="line">    377 U  31.01.97   1100.990     1100.985                            402.05        402.05</span>
<span class="line">    449 U  28.02.97   1100.990     1100.985                             32.45         32.45</span>
<span class="line">.</span>
<span class="line">    699 M  31.03.98   1100.990     3600         8800                    70.00         70.00</span>
<span class="line">    700 M  31.03.98   1100.990     3600         8800                   200.00        200.00</span>
<span class="line">                                                               -------------- -------------</span>
<span class="line">                                                                 1,138,611.15  1,138,611.15 TOTAL</span>
<span class="line">69  COUNT</span>
<span class="line">-------</span>
<span class="line">                                                        -------------- --</span>
<span class="line">                                                                 3,133,577.81   -154,922.29 TOTAL</span>
<span class="line">351  COUNT</span>
<span class="line"></span>
<span class="line">Rekapitulation                                                         Betrag</span>
<span class="line">      Saldo</span>
<span class="line">--------------                                                 -------------- --</span>
<span class="line">                                                  Umsatz         3,124,352.36   -161,772.14</span>
<span class="line">                                                  MWSt               9,225.45      6,849.85</span>
<span class="line">                                                               -------------- --</span>
<span class="line">                                                                 3,133,577.81   -154,922.29 TOTAL</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Mit Belegnummer 449 wurde der Betrag von 32.45 auf das Konto 1100.990 im Soll und 1100.985 im Haben gebucht. Eine Kostenstelle wurde nicht verbucht. Es war eine Buchung vom Typ &quot;U&quot;.</p>
<p>Total der Spalten 'Betrag' und 'Saldo' aus allen verarbeiteten Belegnummern</p>
</div></template>


